import { render, staticRenderFns } from "./BrandCreatorText.vue?vue&type=template&id=57677668&scoped=true&"
import script from "./BrandCreatorText.vue?vue&type=script&lang=js&"
export * from "./BrandCreatorText.vue?vue&type=script&lang=js&"
import style0 from "./BrandCreatorText.vue?vue&type=style&index=0&id=57677668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57677668",
  null
  
)

export default component.exports